import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../../controls";
import { User } from "../../../models/User";

type Props = {
	setUserId: Function;
	setShowEditModal: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setShowChangePasswordModal: Function;
};
export const useUsersOptionsFunctions = ({
	setUserId,
	setShowEditModal,
	setShowDeleteModal,
	setShowCreateModal,
	setShowChangePasswordModal,
}: Props) => {
	const getMenuOptions = (data: User) => {
		let options: MenuOptionType[] = [];
		if (!data) {
			options = options.concat([
				{
					name: "New User",
					key: "new_user",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "New User",
					key: "new_user",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Edit User",
					key: "edit_user",
					onClick: () => {
						setUserId(data.UserId);
						setShowEditModal(true);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete User",
					key: "delete_user",
					onClick: () => {
						setUserId(data.UserId);
						setShowDeleteModal(true);
					},
					icon: <DeleteIcon />,
				},
				{
					name: "Change Password",
					key: "change_password_user",
					onClick: () => {
						setUserId(data.UserId);
						setShowChangePasswordModal(true);
					},
					icon: <LockOutlinedIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
